<script>
  import { previews_sort_order } from '../../stores'
  import InsertFeatureTeaser from './templates/Teaser.svelte'
  import InsertFeatureUpgrade from './templates/Upgrade.svelte'

  export let insert_position
  export let inbetween_counter

</script>

<!-- Before Preview -->
{#if insert_position === 'before_previews'}
  {#if $previews_sort_order != 'random'}
    {#if Math.random() < 0.33}
      <InsertFeatureTeaser feature="sorting" alternative=0/>
    {:else if Math.random() < 0.5}
      <InsertFeatureTeaser feature="sorting" alternative=1/>
    {:else}
      <InsertFeatureTeaser feature="sorting" alternative=2/>
    {/if}
  {/if}
{/if}

<!-- Between Previews -->
{#if insert_position === 'between_previews'}
  {#if inbetween_counter === 1 && $previews_sort_order != 'random'}
    <InsertFeatureUpgrade feature="sorting"/>
  {/if}
{/if}